<form *ngIf="formLink && fields" [formGroup]="formLink" [ngClass]="{'invalid-submit': invalidSubmit}" >

  <div class="card Loyalty">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2>{{ 'common.storeLink' | translate }}</h2>
      </div>
    </div>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.analytics_system' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.analytics" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.backoffice_system' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.backoffice" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.front_end' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.front_end" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.loyalty_system' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.loyalty" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.promotion' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.promotion" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.customer_system' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.customer" readonly />
      </div>
      <div class="ui-g-4 form-control">
        <span class="label">{{ 'storeConfigurationList.couponing_system' | translate }}</span>
        <input pInputText type="text" [value]="linkInfo.couponing" readonly />
      </div>
      <div class="ui-g-8 form-control">
        <span class="label" [ngClass]="{'required': !fields.ip_address.nullable}">{{ fields.ip_address.keyName }}</span>
        <input pInputText type="text" formControlName="ip_address" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.ip_address"></app-validation-msg>
      </div>
      <!-- Url Flyer -->
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.ext_flyer_url.nullable}">{{ fields.ext_flyer_url.keyName }}</span>
        <input pInputText type="text" formControlName="ext_flyer_url"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.ext_flyer_url"></app-validation-msg>
      </div>
      <div class="ui-g-8 form-control"></div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.flg_graphical_printer.nullable}">{{ fields.flg_graphical_printer.keyName }}</span>
        <p-inputSwitch formControlName="flg_graphical_printer"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.flg_graphical_printer"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.flg_campaign_candidate.nullable}">{{ fields.flg_campaign_candidate.keyName }}</span>
        <p-inputSwitch formControlName="flg_campaign_candidate"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.flg_campaign_candidate"></app-validation-msg>
      </div>

    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-link/store-common-link.component.html